import React from 'react'

const PlatformLabel = ({ platform, bothSelected }) => {
  if (!bothSelected) {
    return null
  }

  return (
    <div className="platform-label">
      {platform}
    </div>
  )
}

export default PlatformLabel